import React, { Ref, forwardRef } from 'react';
import { Box, BoxProps } from "@chakra-ui/react";

const CenteredBox = forwardRef(({children, ...props}: BoxProps, ref: Ref<HTMLDivElement>) => {
  return <Box ref={ref} maxW="1280px" m="0 auto" {...props}>{ children }</Box>
})

export default CenteredBox
